import React, { useState, useEffect } from 'react';
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from 'react-router-dom';
import './App.css';

// Components & Pages
import BillStatus from './Components/Dashboard/UserInfo/BillStatus';
import Profile from './Components/Dashboard/UserInfo/Profile';
import HomePage from './Pages/HomePage/HomePage';
import SignUp from './Pages/Auth/SignUp';
import Login from './Pages/Auth/Login';
import About from './Pages/AboutUs/About';
import LimitedTenderView from './Pages/LimitedTenderView/LimitedTenderView';
import PricingPackages from './Components/PricingPackages/PricingPackages';
import BrowsesInMyFavorite from './Components/Dashboard/UserInfo/BrowsesInMyFavorite';
import PublishTenderForm from './Pages/PublishTenderForm/PublishTenderForm';
import OTP from './Pages/Auth/OTP';
import ForgotPassword from './Pages/Auth/ForgotPassword';
import ForgotPasswordOTP from './Pages/Auth/ForgotPasswordOTP';
import NewPassword from './Pages/Auth/NewPassword';
import ContactUs from './Components/Contact/ContactUs';
import TenderDetails from './Pages/TenderDetails/TenderDetails';
import TenderList from './Pages/TenderEdit/TenderList';
import TenderRequestUpdateForm from './Pages/TenderEdit/TenderRequestUpdateForm';
import PricingAfterLogIn from './Components/PricingPackages/PricingAfterLogIn';
import InvoicePage from './Pages/InVoicePage/InVoicePage';
import PayForm from './Pages/PayForm/PayForm';
import TenderPublishDetails from './Pages/PublishTenderForm/TenderPublishDetails';
import MainDashBoard from './Pages/Dashboard/MainDashboard/MainDashBoard';
import SingleInvoiceView from './Pages/InVoicePage/SingleInvoiceView';
import SubscriberDetails from './Pages/SubscriberDetails/SubscriberDetails';
import CheckOutBeforeLogin from './Pages/PayForm/CheckOutBeforeLogin';
import ChangePassword from './Components/Dashboard/UserInfo/ChangePassword';
import PDFViewer from './Pages/PDF/PDFViewer';
import ChangePreferences from './Pages/ChangePreferences/ChangePreferences';
import FeedBackPage from './Pages/FeedBackPage/FeedBackPage';
import TenderTabs from './Components/TenderTabs/TenderTabs';
import PrivateRoute from './Routes/PrivateRoute';
import { MainHeader } from './Components/Header/MainHeader';
import SuccessMessage from './Pages/PaymentMessage/SuccessMessage';
import SignUpAffilate from './Pages/Auth/SignUpAffilate';
import LoginAffiliator from './Pages/Auth/LoginAffiliator';
import AffiliateDashboard from './Pages/DashboardAffiliate/AffiliateDashboard';
import HistoryAffiliate from './Pages/DashboardAffiliate/HistoryAffiliate';
import EditTenderPaymentMessage from './Pages/PaymentMessage/EditTenderPaymentMessage';
import AdvanceSearch from './Pages/AdvanceSearch/AdvanceSearch';
import VerifyProfile from './Pages/DashboardAffiliate/VerifyProfile';
import ShareTenderDetailsView from './Pages/TenderDetails/ShareTenderDetailsView';
import MyPublishTender from './Pages/MyPublishTender/MyPublishTender';
import ViewMyTenderDetails from './Pages/TenderDetails/ViewMyTenderDetails';
import AffiliatorOTP from './Pages/Auth/AffiliatorOTP';

function App() {
  // const [isLoggedIn, setIsLoggedIn] = useState(
  //   () => localStorage.getItem('isLoggedIn') === 'true'
  // );
  // const [isSignUp, setIsSignUp] = useState(
  //   () => localStorage.getItem('isSignUp') === 'true'
  // );

  // useEffect(() => {
  //   localStorage.setItem('isLoggedIn', isLoggedIn);
  // }, [isLoggedIn]);

  // useEffect(() => {
  //   localStorage.setItem('isSignUp', isSignUp);
  // }, [isSignUp]);

  const [isLoggedIn, setIsLoggedIn] = useState(() => {
    return !!(localStorage.getItem('token') || localStorage.getItem('bearer'));
  });

  useEffect(() => {
    localStorage.setItem('isLoggedIn', isLoggedIn);
  }, [isLoggedIn]);

  const handleLogin = () => {
    setIsLoggedIn(true);
  };

  const handleLoginAffiliate = () => {
    setIsLoggedIn(true);
  };

  const handleLogout = () => {
    setIsLoggedIn(false);
  };

  return (
    <div className="App">
      <Router>
        <MainHeader isLoggedIn={isLoggedIn} onLogout={handleLogout} />
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<HomePage />} />
          <Route path="/signup" element={<SignUp />} />
          <Route
            path="/view-tender-details"
            element={<ShareTenderDetailsView />}
          />

          {/* ----------------Affiliator Part start--------------- */}

          <Route path="/signupaffiliator" element={<SignUpAffilate />} />
          <Route path="/forgotPassword" element={<ForgotPassword />} />

          <Route
            path="/affiliator-login"
            element={
              !isLoggedIn ? (
                <LoginAffiliator onLogin={handleLoginAffiliate} />
              ) : (
                <Navigate to="/affiliator-dashboard" />
              )
            }
          />

          {/* Private Routes */}
          <Route
            path="/affiliator-dashboard"
            element={
              <PrivateRoute isLoggedIn={isLoggedIn}>
                <AffiliateDashboard />
              </PrivateRoute>
            }
          />
          <Route
            path="/history"
            element={
              <PrivateRoute isLoggedIn={isLoggedIn}>
                <HistoryAffiliate />
              </PrivateRoute>
            }
          />
          <Route
            path="/view-all-my-publish-tender"
            element={
              <PrivateRoute isLoggedIn={isLoggedIn}>
                <MyPublishTender />
              </PrivateRoute>
            }
          />
          <Route
            path="/verify-profile"
            element={
              <PrivateRoute isLoggedIn={isLoggedIn}>
                <VerifyProfile />
              </PrivateRoute>
            }
          />

          {/* ----------------Affiliator Part end--------------- */}

          <Route path="/otp" element={<OTP onLogin={handleLogin} />} />
          <Route
            path="/verify-affiliator-otp"
            element={<AffiliatorOTP onLogin={handleLoginAffiliate} />}
          />
          <Route
            path="/forgot-password-OTP"
            element={<ForgotPasswordOTP onLogin={handleLogin} />}
          />
          <Route path="/newPassword" element={<NewPassword />} />
          <Route path="/allTenders" element={<TenderTabs />} />
          <Route path="/check-out" element={<CheckOutBeforeLogin />} />
          <Route path="/success-message2XwhRi" element={<SuccessMessage />} />
          <Route path="/pdf-viewer/:id" element={<PDFViewer />} />
          <Route
            path="/login"
            element={
              !isLoggedIn ? (
                <Login onLogin={handleLogin} />
              ) : (
                <Navigate to="/dashboard" />
              )
            }
          />

          <Route path="/about" element={<About />} />
          {/* <Route path="/services" element={<Services />} /> */}
          <Route path="/contactUs" element={<ContactUs />} />
          <Route path="/tenderpublish" element={<PublishTenderForm />} />
          <Route path="/pricing" element={<PricingPackages />} />
          <Route path="/limitedTenderView" element={<LimitedTenderView />} />
          <Route path="/invoice" element={<InvoicePage />} />
          {/* <Route path="/advance-search" element={<AdvanceSearch />} /> */}
          <Route
            path="/tenderpublishDetails"
            element={<TenderPublishDetails />}
          />

          {/* Private Routes */}
          <Route
            path="/dashboard"
            element={
              <PrivateRoute isLoggedIn={isLoggedIn}>
                <MainDashBoard />
              </PrivateRoute>
            }
          />
          <Route
            path="/tenderpublish"
            element={
              <PrivateRoute isLoggedIn={isLoggedIn}>
                <PublishTenderForm />
              </PrivateRoute>
            }
          />
          <Route
            path="/advance-search"
            element={
              <PrivateRoute isLoggedIn={isLoggedIn}>
                <AdvanceSearch />
              </PrivateRoute>
            }
          />
          <Route
            path="/tenderpublishDetails"
            element={
              <PrivateRoute isLoggedIn={isLoggedIn}>
                <TenderPublishDetails />
              </PrivateRoute>
            }
          />
          <Route
            path="/invoice"
            element={
              <PrivateRoute isLoggedIn={isLoggedIn}>
                <InvoicePage />
              </PrivateRoute>
            }
          />
          <Route
            path="/invoice-details/:id"
            element={
              <PrivateRoute isLoggedIn={isLoggedIn}>
                <SingleInvoiceView />
              </PrivateRoute>
            }
          />
          <Route
            path="/subscriber-details/:id"
            element={
              <PrivateRoute isLoggedIn={isLoggedIn}>
                <SubscriberDetails />
              </PrivateRoute>
            }
          />
          <Route
            path="/pdf-viewer/:id"
            element={
              <PrivateRoute isLoggedIn={isLoggedIn}>
                <PDFViewer />
              </PrivateRoute>
            }
          />
          <Route
            path="/tenderRequestUpdateForm/:id"
            element={
              <PrivateRoute isLoggedIn={isLoggedIn}>
                <TenderRequestUpdateForm />
              </PrivateRoute>
            }
          />
          <Route
            path="/viewTenderDetails/:id"
            element={
              <PrivateRoute isLoggedIn={isLoggedIn}>
                <TenderDetails />
              </PrivateRoute>
            }
          />
          <Route
            path="/view-my-tender-details/:id"
            element={
              <PrivateRoute isLoggedIn={isLoggedIn}>
                <ViewMyTenderDetails />
              </PrivateRoute>
            }
          />
          <Route
            path="/changePreferences"
            element={
              <PrivateRoute isLoggedIn={isLoggedIn}>
                <ChangePreferences />
              </PrivateRoute>
            }
          />
          <Route
            path="/feedBackPage"
            element={
              <PrivateRoute isLoggedIn={isLoggedIn}>
                <FeedBackPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/payform"
            element={
              <PrivateRoute isLoggedIn={isLoggedIn}>
                <PayForm />
              </PrivateRoute>
            }
          />
          <Route
            path="/change-password"
            element={
              <PrivateRoute isLoggedIn={isLoggedIn}>
                <ChangePassword />
              </PrivateRoute>
            }
          />
          <Route
            path="/billstatus"
            element={
              <PrivateRoute isLoggedIn={isLoggedIn}>
                <BillStatus />
              </PrivateRoute>
            }
          />
          <Route
            path="/profile"
            element={
              <PrivateRoute isLoggedIn={isLoggedIn}>
                <Profile />
              </PrivateRoute>
            }
          />
          <Route
            path="/editMyTender"
            element={
              <PrivateRoute isLoggedIn={isLoggedIn}>
                <TenderList />
              </PrivateRoute>
            }
          />
          <Route
            path="/myfavorite"
            element={
              <PrivateRoute isLoggedIn={isLoggedIn}>
                <BrowsesInMyFavorite />
              </PrivateRoute>
            }
          />
          <Route
            path="/pricingPackages"
            element={
              <PrivateRoute isLoggedIn={isLoggedIn}>
                <PricingAfterLogIn />
              </PrivateRoute>
            }
          />

          <Route
            path="/editMyTender/return-url"
            element={
              <PrivateRoute isLoggedIn={isLoggedIn}>
                <EditTenderPaymentMessage />
              </PrivateRoute>
            }
          />

          {/* Fallback Route after login*/}
          <Route
            path="*"
            element={
              <PrivateRoute isLoggedIn={isLoggedIn}>
                <MainDashBoard />
              </PrivateRoute>
            }
          />
          {/* Fallback Route before login*/}
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
        {/* <Contact/> */}
      </Router>
    </div>
  );
}

export default App;

// Old routes
// import React, { useState, useEffect } from 'react';
// import {
//   BrowserRouter as Router,
//   Route,
//   Routes,
//   Navigate,
// } from 'react-router-dom';
// import './App.css';
// // import MainDashBoard from './Components/Dashboard/MainDashBoard';
// import Header from './Components/Header/Header';
// import Services from './Components/Service/Services';
// import AllTenders from './Components/Dashboard/TenderDetails/AllTenders';
// import BillStatus from './Components/Dashboard/UserInfo/BillStatus';
// import Profile from './Components/Dashboard/UserInfo/Profile';
// import MyFavorite from './Components/Dashboard/UserInfo/MyFavorite';
// import EditMyTender from './Components/Dashboard/UserInfo/EditMyTender';
// import OurCoursesMain from './Components/OurCourses/OurCoursesMain';
// import OurCoursesHeader from './Components/OurCourses/OurCoursesHeader';
// import TeacherList from './Components/OurCourses/TeacherList/TeacherList';
// import OurCourses from './Components/OurCourses/OurCourses';
// import OurCoursesContactUs from './Components/OurCourses/OurCoursesContactUs';
// import RegisterHero from './Components/OurCourses/Register/RegisterHero';
// import HomePage from './Pages/HomePage/HomePage';
// import SignUp from './Pages/Auth/SignUp';
// import Login from './Pages/Auth/Login';
// // import ContactUs from './Pages/ContactUs/ContactUs';
// import About from './Pages/AboutUs/About';
// import TenderPublish from './Pages/TenderPublish/TenderPublish';
// import LimitedTenderView from './Pages/LimitedTenderView/LimitedTenderView';
// import PricingPackages from './Components/PricingPackages/PricingPackages';
// import BrowsesInMyFavorite from './Components/Dashboard/UserInfo/BrowsesInMyFavorite';
// import PublishTenderForm from './Pages/PublishTenderForm/PublishTenderForm';
// import ViewTenderDetails from './Pages/TenderDetails/ViewTenderDetails';
// import OTP from './Pages/Auth/OTP';
// import ForgotPassword from './Pages/Auth/ForgotPassword';
// import ForgotPasswordOTP from './Pages/Auth/ForgotPasswordOTP';
// import NewPassword from './Pages/Auth/NewPassword';
// import ContactUs from './Components/Contact/ContactUs';
// import TenderDetails from './Pages/TenderDetails/TenderDetails';
// import TenderList from './Pages/TenderEdit/TenderList';
// import createApiClient from './Api/apiClient'; // Import the factory funct
// import TenderRequestUpdateForm from './Pages/TenderEdit/TenderRequestUpdateForm';
// import PricingAfterLogIn from './Components/PricingPackages/PricingAfterLogIn';
// import InvoicePage from './Pages/InVoicePage/InVoicePage';
// import PayForm from './Pages/PayForm/PayForm';
// import TenderPublishDetails from './Pages/PublishTenderForm/TenderPublishDetails';
// import MainDashBoard from './Pages/Dashboard/MainDashboard/MainDashBoard';
// import SingleInvoiceView from './Pages/InVoicePage/SingleInvoiceView';
// import SubscriberDetails from './Pages/SubscriberDetails/SubscriberDetails';
// import CheckOutBeforeLogin from './Pages/PayForm/CheckOutBeforeLogin';
// import ChangePassword from './Components/Dashboard/UserInfo/ChangePassword';
// import PDFViewer from './Pages/PDF/PDFViewer';
// import ChangePreferences from './Pages/ChangePreferences/ChangePreferences';
// import FeedBackPage from './Pages/FeedBackPage/FeedBackPage';
// import TenderTabs from './Components/TenderTabs/TenderTabs';
// import DashBoardHeader from './Components/Header/DashBoardHeader';

// function App() {
//   const [isLoggedIn, setIsLoggedIn] = useState(
//     () => localStorage.getItem('isLoggedIn') === 'true'
//   );
//   const [isSignUp, setIsSignUp] = useState(
//     () => localStorage.getItem('isSignUp') === 'true'
//   );
//   const [isOurCourses, setIsOurCourses] = useState(
//     () => localStorage.getItem('isOurCourses') === 'true'
//   );

//   useEffect(() => {
//     // Store isOurCourses state in localStorage
//     localStorage.setItem('isOurCourses', isOurCourses);
//   }, [isOurCourses]);

//   // const [isOurCourses, setIsOurCourses] = useState(false);

//   // useEffect(() => {
//   //   console.log('isOurCourses:', isOurCourses);
//   // }, [isOurCourses]);

//   useEffect(() => {
//     localStorage.setItem('isLoggedIn', isLoggedIn);
//   }, [isLoggedIn]);

//   useEffect(() => {
//     localStorage.setItem('isSignUp', isSignUp);
//   }, [isSignUp]);

//   const handleCloseOurCourses = () => {
//     setIsOurCourses(false);
//   };

//   const handleLogin = () => {
//     setIsLoggedIn(true);
//     setIsSignUp(false);
//     setIsOurCourses(false);
//   };

//   const handleSignUp = () => {
//     setIsLoggedIn(false);
//     setIsSignUp(true);
//     setIsOurCourses(false);
//   };

//   const handleGoogleSignIn = () => {
//     setIsSignUp(true);
//     setIsOurCourses(false);
//   };

//   const handleLogout = () => {
//     setIsLoggedIn(false);
//     setIsSignUp(false);
//     setIsOurCourses(false);
//   };

//   return (
//     <div className="App">
//       <Router>
//         {isLoggedIn || isSignUp ? (
//           isOurCourses ? (
//             <>
//               <OurCoursesHeader onClose={handleCloseOurCourses} />
//               <Routes>
//                 <Route path="/ourcourses" element={<OurCoursesMain />} />
//                 <Route path="/ourcoursesSub" element={<OurCourses />} />
//                 <Route path="/teacherList" element={<TeacherList />} />

//                 <Route
//                   path="/contactUsFromOurCourses"
//                   element={<OurCoursesContactUs />}
//                 />
//                 <Route
//                   path="/login"
//                   element={<Login onLogin={handleLogin} />}
//                 />
//                 <Route
//                   path="/signup"
//                   element={<SignUp onSignUp={handleSignUp} />}
//                 />
//                 <Route path="/register" element={<RegisterHero />} />
//                 <Route path="*" element={<Navigate to="/ourcourses" />} />
//               </Routes>
//             </>
//           ) : (
//             <>
//               <DashBoardHeader
//                 setIsOurCourses={setIsOurCourses}
//                 onLogout={handleLogout}
//               />
//               <Routes>
//                 <Route path="/dashboard" element={<MainDashBoard />} />
//                 <Route path="/changePreferences" element={ <ChangePreferences/> } />
//                 <Route path="/feedBackPage" element={ <FeedBackPage/> } />

//                 {/* <Route path="/TooggleUserInfo" element={<TooggleUserInfo />} /> */}
//                 <Route path="/invoice" element={<InvoicePage />} />
//                 <Route
//                   path="/invoice-details/:id"
//                   element={<SingleInvoiceView />}
//                 />
//                 <Route
//                   path="/subscriber-details/:id"
//                   element={<SubscriberDetails />}
//                 />
//                 <Route path="/payform" element={<PayForm />} />
//                 <Route path="/change-password" element={<ChangePassword />} />
//                 <Route path="/about" element={<About />} />
//                 <Route path="/billstatus" element={<BillStatus />} />
//                 {/* <Route path="/billstatus" element={<AllSubcriberList />} /> */}
//                 <Route path="/profile" element={<Profile />} />
//                 {/* <Route path="/editMyTender" element={<EditMyTender />} /> */}
//                 <Route path="/editMyTender" element={<TenderList />} />
//                 {/* <Route path="/myfavorite" element={<MyFavorite />} /> */}
//                 <Route path="/myfavorite" element={<BrowsesInMyFavorite />} />
//                 <Route
//                   path="/pricingPackages"
//                   element={<PricingAfterLogIn />}
//                 />
//                 {/* <Route path="/pricingPackages" element={<PricingPackages />} /> */}
//                 <Route path="/contactUs" element={<ContactUs />} />
//                 <Route path="/AllTenders" element={<AllTenders />} />
//                 <Route path="/tenderpublish" element={<PublishTenderForm />} />
//                 <Route
//                   path="/tenderpublishDetails"
//                   element={<TenderPublishDetails />}
//                 />
//                 <Route path="/pdf-viewer/:id" element={<PDFViewer />} />
//                 <Route
//                   path="/tenderRequestUpdateForm/:id"
//                   element={<TenderRequestUpdateForm />}
//                 />
//                 <Route
//                   path="/ViewTenderDetails/:id"
//                   element={<TenderDetails />}
//                 />
// <Route path="*" element={<Navigate to="/dashboard" />} />
//               </Routes>
//             </>
//           )
//         ) : isOurCourses ? (
//           <>
//             <OurCoursesHeader onClose={handleCloseOurCourses} />
//             <Routes>
//               <Route path="/ourcourses" element={<OurCoursesMain />} />
//               <Route path="/ourcoursesSub" element={<OurCourses />} />
//               <Route path="/teacherList" element={<TeacherList />} />
//               <Route
//                 path="/contactUsFromOurCourses"
//                 element={<OurCoursesContactUs />}
//               />
//               <Route path="/login" element={<Login onLogin={handleLogin} />} />
//               <Route
//                 path="/signup"
//                 element={<SignUp onSignUp={handleSignUp} />}
//               />
//               <Route path="/register" element={<RegisterHero />} />
//               <Route path="*" element={<Navigate to="/ourcourses" />} />
//             </Routes>
//           </>
//         ) : (
//           <>
//             <Header setIsOurCourses={setIsOurCourses} />
//             <Routes>
//               {/* <Route path="/" element={<Hero />} /> */}
//               <Route path="/" element={<HomePage />} />
//               <Route path="/signup" element={<SignUp />} />

//               <Route path="/otp" element={<OTP onLogin={handleLogin} />} />
//               <Route
//                 path="/forgot-password-OTP"
//                 element={<ForgotPasswordOTP onLogin={handleLogin} />}
//               />
//               <Route path="/forgotPassword" element={<ForgotPassword />} />
//               <Route path="/newPassword" element={<NewPassword />} />
//               <Route path="/login" element={<Login onLogin={handleLogin} />} />
//               <Route path="/about" element={<About />} />
//               <Route
//                 path="/limitedTenderView"
//                 element={<LimitedTenderView />}
//               />
//   <Route path="/allTenders" element={ <TenderTabs /> } />
// <Route path="/check-out" element={<CheckOutBeforeLogin />} />
// <Route path="/pdf-viewer/:id" element={<PDFViewer />} />
//               {/* <Route path="/pdf-viewer" element={<PDFViewer />} /> */}
//               {/* <Route
//                 path="/starter"
//                 element={
//                   <iframe
//                     src="/cuba-admin-template/starter-kit/index.html"
//                     // title="Normal Project 1"
//                     style={{ width: '100%', height: '100vh', border: 'none' }}
//                   />
//                 }
//               /> */}
//               <Route
//                 path="/viewTenderDetails/:id"
//                 element={<ViewTenderDetails />}
//               />
//               {/* <Route path="/invoice" element={<InvoicePage />} /> */}
// <Route path="/invoice" element={<InvoicePage />} />
//               <Route path="/pricing" element={<PricingPackages />} />
//               {/* <Route path="/pricing" element={<PricingAfterLogIn />} /> */}
//               {/* <Route path="/tenderpublish" element={<TenderPublish />} /> */}
//               <Route path="/tenderpublish" element={<PublishTenderForm />} />
// <Route
//   path="/tenderpublishDetails"
//   element={<TenderPublishDetails />}
// />
//               <Route path="/services" element={<Services />} />
//               <Route path="/contactUs" element={<ContactUs />} />
//               <Route path="*" element={<Navigate to="/" />} />
//             </Routes>
//           </>
//         )}
//       </Router>
//     </div>
//   );
// }

// export default App;
